// mds-dojo — dojo/has — faithful port of references/dojo/has.js (the has.js feature
// API + dojo's base feature tests). The AMD-plugin bits (has.normalize / has.load)
// are dropped — they resolve `has!` module ids at load time, which Vite doesn't use.
// The runtime surface widgets rely on — has(name), has.add(name,test,now,force),
// has.cache, has.clearElement — is faithful.

const glob: any = globalThis as any;

const isBrowser =
  typeof window != 'undefined' &&
  typeof location != 'undefined' &&
  typeof document != 'undefined' &&
  (window as any).location == location && (window as any).document == document;

const doc: any = isBrowser && document;
const element: any = doc && doc.createElement('DiV');
const cache: any = {};

interface HasApi {
  (name: string): any;
  cache: any;
  add: (name: string, test: any, now?: boolean, force?: boolean) => any;
  clearElement: (el: any) => any;
}

const has = function (name: string): any {
  return typeof cache[name] == 'function' ? (cache[name] = cache[name](glob, doc, element)) : cache[name];
} as HasApi;

has.cache = cache;

has.add = function (name: string, test: any, now?: boolean, force?: boolean): any {
  if (typeof cache[name] == 'undefined' || force) { cache[name] = test; }
  return now && has(name);
};

has.clearElement = function (el: any): any {
  el.innerHTML = '';
  return el;
};

// dojo base feature tests
has.add('host-browser', isBrowser);
// host-node: read `process` off globalThis so mds-dojo doesn't depend on the
// CONSUMER project's ambient node typings (`@types/node` in tsconfig `types`).
// The big-app host restricts `types` to browser packages on purpose (pulling in
// "node" would leak NodeJS.Timeout etc. into a browser app); dojo itself did this
// as runtime feature-detection, never a typings dep — behaviour identical.
has.add('host-node', (() => {
  const proc = (globalThis as any).process;
  return typeof proc == 'object' && proc && proc.versions && proc.versions.node && proc.versions.v8;
})());
has.add('dom', isBrowser);
has.add('dojo-dom-ready-api', 1);
has.add('dojo-sniff', 1);
has.add('dojo-has-api', true);

if (has('host-browser')) {
  has.add('dom-addeventlistener', !!document.addEventListener);
  has.add('touch', 'ontouchstart' in document
    || ('onpointerdown' in document && (navigator as any).maxTouchPoints > 0)
    || (window.navigator as any).msMaxTouchPoints);
  has.add('touch-events', 'ontouchstart' in document);
  has.add('pointer-events', 'pointerEnabled' in window.navigator
    ? (window.navigator as any).pointerEnabled : 'PointerEvent' in window);
  has.add('MSPointer', (window.navigator as any).msPointerEnabled);
  has.add('touch-action', has('touch') && has('pointer-events'));
  has.add('device-width', (screen as any).availWidth || (window as any).innerWidth);
  const form = document.createElement('form');
  has.add('dom-attributes-explicit', form.attributes.length == 0);
  has.add('dom-attributes-specified-flag', form.attributes.length > 0 && form.attributes.length < 40);
}

export default has;
